module.exports = __webpack_public_path__ + "static/img/office-img-2.28c3780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-2.jpg
// module id = 43cf
// module chunks = 0